import { sectionNames } from "@dashboard/intl";
import { MenuItemTarget,MenuItemType } from "@dashboard/structures/components/MenuItemDialog";
import { IntlShape } from "react-intl";

export const getLinkTypeOptions = (intl: IntlShape) =>
  [
    {
      value: "category",
      label: intl.formatMessage(sectionNames.categories),
    },
    {
      value: "collection",
      label: intl.formatMessage(sectionNames.collections),
    },
    {
      value: "page",
      label: intl.formatMessage(sectionNames.models),
    },
    {
      value: "link",
      label: intl.formatMessage({
        id: "H1L1cc",
        defaultMessage: "URL",
        description: "url",
      }),
    },
  ] satisfies Array<{ value: MenuItemType; label: string }>;

export const getTargetOptions = (intl: IntlShape) =>
  [
    {
      value: "_self",
      label: intl.formatMessage({
        id: 'QPRkRl',
        defaultMessage: "Same tab",
        description: "link target same tab",
      }),
    },
    {
      value: "_blank",
      label: intl.formatMessage({
        id: 'Resiov',
        defaultMessage: "New tab",
        description: "link target new tab",
      }),
    },
  ] satisfies Array<{ value: MenuItemTarget; label: string }>;
